export default __webpack_public_path__ + "static/media/encrypted-ph-colored.76e0d39e.webp";